export const eur = (n) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const deDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return new Intl.DateTimeFormat("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" }).format(d);
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const yearOf = (iso) => {
  const d = new Date(iso);
  return isNaN(d) ? "—" : String(d.getFullYear());
};

export const addDaysISO = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + Number(days || 0));
  return d.toISOString().slice(0, 10);
};

export const STATUS = {
  entwurf: { label: "Entwurf", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  offen: { label: "Offen", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  bezahlt: { label: "Bezahlt", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  ueberfaellig: { label: "Überfällig", cls: "bg-red-50 text-red-700 border-red-200" },
  storniert: { label: "Storniert", cls: "bg-slate-100 text-slate-500 border-slate-300" },
};

// Open invoice past its due date -> overdue (derived, status stays "offen")
export const isOverdue = (inv) =>
  inv?.status === "offen" && inv?.due_date && inv.due_date < todayISO();

// Badge style to render, accounting for the derived overdue state
export const badgeFor = (inv) => (isOverdue(inv) ? STATUS.ueberfaellig : STATUS[inv?.status] || STATUS.offen);

// German dunning level label from reminder_level (1 = Zahlungserinnerung, 2 = 1. Mahnung, ...)
export const reminderLabel = (level) =>
  !level || level <= 1 ? "Zahlungserinnerung" : `${level - 1}. Mahnung`;
